<script lang="ts">
import { useTailwind } from '@/plugins/useTailwind'
import { defineComponent, useTemplateRef } from 'vue'

import type AppCarousel from '../carousel/AppCarousel.vue'
import CarouselItem from '../carousel/CarouselItem.vue'

/**
 * The "Partner" sponsor overview page.
 */
export default defineComponent({
  components: {
    CarouselItem,
  },
  setup() {
    const tailwind = useTailwind()
    const bannerRef = useTemplateRef<HTMLElement>('bannerRef')
    const carouselRef =
      useTemplateRef<InstanceType<typeof AppCarousel>>('carouselRef')

    return {
      tailwindBreakpoints: tailwind.breakpoints,
      bannerRef,
      carouselRef,
    }
  },
})
</script>

<template>
  <aside class="partner-banner mt-4 mb-4">
    <AppCarousel
      ref="carouselRef"
      class="max-w-screen-xl mx-auto"
      :show-navigation="false"
    >
      <CarouselItem
        v-for="(logo, key) in $theme.assets.partners"
        :key="key"
        class="flex items-center justify-center"
      >
        <div class="flex h-full justify-center rounded-lg px-6 py-4">
          <img :src="logo" alt="" class="max-h-12 object-contain" />
        </div>
      </CarouselItem>
    </AppCarousel>
  </aside>
</template>

<style lang="scss" scoped>
.partner-banner:deep(.scrollbox ul) {
  @apply justify-center;
}
</style>
